import {Box, CardMedia} from "@mui/material";
import WebTheme from "./WebTheme";
import {CajaTextoLectura, CajaTextoMediano, RotuloWebMediano} from "./CajasTexto";
import React from "react";
import Link from "@mui/material/Link";


export default function WebViewer({estilo,type,rotuloWeb,textoWeb,imagenesWeb,eventsList,imagesList,onLinkClicked,rotuloLinks})
{
    return (
        <Box
            sx={{
                border: (estilo.background === 'black')?'solid 2px White':WebTheme.borderLines.lineaGreen,
                width: '80%',
                ml: '15%',
            }}
        >
            {/* Para visualizar eventos */}
            {type === 'event' && (
                <Box sx = {{minHeight:'100vh'}}>
                    <CajaTextoMediano texto={rotuloWeb} estiloPagina={estilo} />
                    <CajaTextoLectura texto={textoWeb} estiloPagina={estilo} marginLeft="1%" />
                    {imagenesWeb.map((imagen, index) => (
                        <CardMedia
                            component="img"
                            key={index}
                            image={imagen}
                            sx={{ width: '24%', display: 'inline', ml: '1%' }}
                            loading="lazy"
                        />
                    ))}
                </Box>
            )}
            {/*Para visualizar links */}
            {type === 'links' && (
            <Box sx={{minHeight:'100vh'}}>
                <RotuloWebMediano estiloPagina= {estilo} texto={rotuloLinks} marginLeft={'auto'} marginBottom={'5%'}></RotuloWebMediano>
                {eventsList.map((url, index) => (
                        <Link sx={{display: 'block', fontSize: WebTheme.fontSizes.grande, mb: '1%', ml:'1%'}}
                              key={index}
                              href={'#'}
                              onClick={onLinkClicked}
                              target="_blank"
                              rel="noopener noreferrer">
                            {url}
                        </Link>
                    )
                )}
            </Box>
            )}
            {/*Para visualizar imagenes */}
            {type === 'images' && (
                <Box sx={{width:'100%',height:'auto'}}>
                    <RotuloWebMediano estiloPagina= {estilo} texto={rotuloWeb} marginLeft={'auto'} marginBottom={'5px'}></RotuloWebMediano>
                    {imagesList.map((imgSrc, idx) => (
                        <Box
                            component="img"
                            src = {imgSrc}
                            alt={`Imagen ${idx + 1}`}
                            sx={{height:'300px',objectFit:'cover',display:'inline-block',mr:'2%',mb:'2%'}}
                            loading="lazy"
                        />
                    ))}
                </Box>
            )}
        </Box>
    );

}
